/** The id baked into this bundle. index.html carries the same value for the live deploy. */
export const BUILD_ID: string = __REDCHAIN_BUILD__;

const META = /name="redchain-build"\s+content="([^"]+)"/;

export function buildIdFromHtml(html: string): string | null {
  return META.exec(html)?.[1] ?? null;
}

/** True when this bundle is the one index.html currently serves. A fetch failure does not force a reload. */
export async function buildMatchesDeploy(fetchHtml: () => Promise<string> = async () => {
  const res = await fetch(`/?build=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) return "";
  return res.text();
}): Promise<boolean> {
  try {
    const html = await fetchHtml();
    const live = buildIdFromHtml(html);
    if (!live) return true;
    return live === BUILD_ID;
  } catch {
    return true;
  }
}
